/**
 * It converts a year Number into a Roman numeral String
 * @param { Number } year
 * @returns { String } Returns a String of Roman Numerals
 */
export function convertToRoman(year) {
	// Traditional Roman numerals only support numbers from 1 to 3999
	if (year < 1 || year > 3999) {
		return 'Enter a year between 1 and 3999';
	}

	const lookup = [
		['M', 1000],
		['CM', 900],
		['D', 500],
		['CD', 400],
		['C', 100],
		['XC', 90],
		['L', 50],
		['XL', 40],
		['X', 10],
		['IX', 9],
		['V', 5],
		['IV', 4],
		['I', 1],
	];

	let roman = '';

	for (const [numeral, value] of lookup) {
		while (year >= value) {
			roman += numeral;
			year -= value;
		}
	}

	return roman;
}

// Example usage:
// console.log(convertToRoman(2026)); // Output: MMXXVI
// console.log(convertToRoman(1994)); // Output: MCMXCIV
